module.exports = __webpack_public_path__ + "static/analytics-workforce-management@3x-73907e1a11127a3a803a18a0555dc56a.png";